export * from './ubiScrollPosition.directive';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/directives/ubiScrollPosition/index.ts